import React from "react";
import { Container, Title, Text, Paper, Button } from "@mantine/core";
import AlbumSlideshow, {
  SectionConfig,
  TravelSectionData,
  GallerySectionData,
  SplitSectionData,
  TextSectionData,
} from "./AlbumSlideshow";
import { FullScreen, useFullScreenHandle } from "react-full-screen";

// Example configuration for the slideshow
const exampleSections: SectionConfig[] = [
  {
    id: "split-1",
    type: "split",
    title: "Día 1 - Barcelona > Cracovia",
    data: {
      leftSection: {
        id: "travel-1",
        type: "travel",
        data: {
          origin: [2.1734, 41.3878], // Barcelona coordinates
          destination: [19.9372, 50.0613], // Cracovia coordinates
          autoPlay: true,
          autoPlayDelayMs: 1000,
          interactive: false,
          showRouteLine: true,
          projection: "mercator",
          zoom: 10,
        } as TravelSectionData,
      },
      rightSection: {
        id: "gallery-split",
        type: "gallery",
        title: "Photos",
        data: {
          folderId: "e9939b98-7587-47c0-b560-0120fe449998",
          pageSize: 15,
          enableInfiniteLoading: true,
          isSelectionEnabled: false,
          hiddenOptions: true,
          isMiniGallery: true,
          hardcodeSettings: {
            photoAlbum_layout: "rows",
            photoAlbum_spacing: 8,
          },
        } as GallerySectionData,
      },
      leftWidth: 60, // 60% width for travel section
      rightWidth: 40, // 40% width for gallery section
      gap: 10, // 20px gap between sections
    } as SplitSectionData,
  },
  {
    id: "gallery-2",
    type: "gallery",
    title: "Día 1 - Free tour",
    data: {
      folderId: "1b34acd9-2066-46f7-b7d1-9177be9cc49b",
      pageSize: 20,
      enableInfiniteLoading: true,
      isSelectionEnabled: false,
      hiddenOptions: true,
      isMiniGallery: false,
    } as GallerySectionData,
  },
  {
    id: "travel-2",
    type: "travel",
    title: "Día 4 - Cracovia > Varsovia",
    data: {
      origin: [19.9372, 50.0613], // Varsovia coordinates
      destination: [21.0111, 52.23], // Cracovia coordinates
      autoPlay: true,
      autoPlayDelayMs: 1000,
      interactive: false,
      showRouteLine: true,
      projection: "mercator",
      zoom: 8,
    } as TravelSectionData,
  },
  {
    id: "gallery-3",
    type: "gallery",
    title: "Día 4 - Chopin y patera",
    data: {
      folderId: "4ff5b083-4b10-423e-826c-bc2a9f86894b",
      pageSize: 20,
      enableInfiniteLoading: true,
      isSelectionEnabled: false,
      hiddenOptions: true,
      isMiniGallery: false,
    } as GallerySectionData,
  },
  {
    id: "text-1",
    type: "text",
    title: "Travel Story",
    data: {
      content: `
        <h2>Journey to Poland</h2>
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl. Nullam euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl. Nullam euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl.</p>
        
        <h3>Highlights</h3>
        <ul>
          <li>Stunning architecture in Barcelona</li>
          <li>Historic charm of Cracovia</li>
          <li>Modern beauty of Varsovia</li>
          <li>Beautiful landscapes along the way</li>
        </ul>
        
        <blockquote>
          <p>"Travel is the only thing you buy that makes you richer."</p>
        </blockquote>
        
        <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl. Nullam euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl. Nullam euismod, nisl eget ultricies ultrices, orci ipsum aliquam nisi, eu tincidunt nisi nisl eu nisl.</p>
      `,
      isEditable: false,
      showToolbar: false,
      variant: "subtle",
    } as TextSectionData,
  },
  {
    id: "text-2",
    type: "text",
    title: "Editable Notes",
    data: {
      content: "<p>Add your personal notes about this trip here...</p>",
      isEditable: true,
      placeholder: "Start writing your thoughts about this journey...",
      showToolbar: true,
      variant: "default",
      onContentChange: (content: string) => {
        console.log("Content changed:", content);
        // Here you could save the content to a backend or local storage
      },
    } as TextSectionData,
  },
];

export default function AlbumSlideshowExample() {
  return (
    <Container size="xl" className="min-h-full h-full" p={0}>
      {/* <Title order={2} mb="md">
        Album Slideshow Example
      </Title>
      <Text c="dimmed" mb="lg">
        This example demonstrates the AlbumSlideshow component with different
        types of sections. Use the navigation controls at the bottom to move
        between slides.
      </Text> */}

      <AlbumSlideshow
        title="Vacaciones en Polonia"
        sections={exampleSections}
        autoPlay={false}
        autoPlayDelayMs={3000}
      />
    </Container>
  );
}
